import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function MachineList({ machines, licenceKey, onDeactivate }) {
  const [loading, setLoading] = useState(null);
  const { t, i18n } = useTranslation("dashboard");

  const handleDeactivate = async (fingerprint) => {
    setLoading(fingerprint);
    try { await onDeactivate(licenceKey, fingerprint); } finally { setLoading(null); }
  };

  if (machines.length === 0) return <p className="text-xs text-[#A1A1AA] mt-4">{t("machineList.empty")}</p>;

  return (
    <div className="mt-4 space-y-2">
      {machines.map((m, idx) => (
        <div key={m.fingerprint} className="flex flex-wrap items-center justify-between gap-2 bg-[#0a0a0c] rounded px-4 py-3">
          <div className="min-w-0">
            <p className="text-sm text-white">{t("machineList.machine", { number: idx + 1 })}</p>
            <p className="text-xs text-[#A1A1AA] mt-0.5">
              {t("machineList.activated", { date: new Date(m.activated_at).toLocaleDateString(i18n.language) })} &middot; {t("machineList.lastSeen", { date: new Date(m.last_validated_at).toLocaleDateString(i18n.language) })}
            </p>
          </div>
          <button onClick={() => handleDeactivate(m.fingerprint)} disabled={loading === m.fingerprint}
            className="text-xs text-red-400 hover:text-red-300 disabled:opacity-50">
            {loading === m.fingerprint ? "..." : t("machineList.deactivate")}
          </button>
        </div>
      ))}
    </div>
  );
}
